import { render, staticRenderFns } from "./parallaxObject.vue?vue&type=template&id=f5dc3b6e&"
import script from "./parallaxObject.vue?vue&type=script&lang=js&"
export * from "./parallaxObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "parallaxObject.vue"
export default component.exports